import { render, staticRenderFns } from "./FornecedorWFDetalheFiscal.vue?vue&type=template&id=1c54dafc&"
import script from "./FornecedorWFDetalheFiscal.vue?vue&type=script&lang=js&"
export * from "./FornecedorWFDetalheFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports